import script from "./RejectClaimModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RejectClaimModal.vue?vue&type=script&setup=true&lang=ts"

import "./RejectClaimModal.vue?vue&type=style&index=0&id=2869fb8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2869fb8e"]])

export default __exports__